module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_K.59daff5b.jpg";